import React from 'react';

const Dashboard = () => {
  return (
    <div>
      <h1>Dashboard</h1>
      <p>Willkommen auf dem Dashboard!</p>
    </div>
  );
};

export default Dashboard;
